import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import secondaryBanner from "../../assets/sec-banner.png";
import secondary1Banner from "../../assets/sec12.png";
import Layout from "../../components/shared/layout/layout";

const images = [
  secondaryBanner,
  secondary1Banner
];

export default function TechFoundationPage() {
  return (
    <Layout>
    <div className="bg-white text-gray-800 font-sans">
      {/* HERO */}
      <section className="bg-gradient-to-tr from-blue-50 to-pink-100 py-20 px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-extrabold text-blue-700 leading-snug mb-4">
            Tech Foundation for JAMBites & School Leavers 🎓
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-6 leading-relaxed">
            Just finished secondary school or waiting for admission? Learn in-demand tech skills in 6 weeks and build your future before university begins.
          </p>
          <button
            className="bg-pink-600 hover:bg-pink-700 transition px-8 py-3 rounded-full text-white text-lg shadow-md"
            onClick={() => window.scrollTo({ top: 800, behavior: 'smooth' })}
          >
            Reserve Your Spot Now
          </button>
        </div>
      </section>

    {/* FLEX SECTION: SLIDER + LEARNING OUTCOMES */}
      <section className="flex flex-col items-center lg:flex-row xl:flex-row md:items-center max-w-6xl mx-auto md:py-16 gap-10 py-8 ">
        {/* IMAGE SLIDER */}
        <div className="w-1/2">
          <Swiper
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3500 }}
            className="rounded-xl w-full h-full"
          >
            {images.map((img, i) => (
              <SwiperSlide key={i}>
                <img
                  src={img}
                  alt={`Poster ${i + 1}`}
                  className="w-full object-cover rounded-xl shadow-lg"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      
        {/* WHAT YOU’LL LEARN */}
        <div className="w-1/2">
          <h2 className="text-3xl font-bold text-blue-700 mb-6 text-left">
            📌 What You’ll Learn in 12 Weeks
        </h2>
          <p className="text-gray-600 mb-8 text-base md:text-lg">
            This beginner-friendly program is perfect for those with little or no tech experience. You'll walk away with real, usable skills.
          </p>
          <div className="grid grid-cols-1 gap-6 text-left text-gray-700 text-base">
            <ul className="list-disc pl-6 space-y-2">
              <li>💻 Build websites with HTML, CSS & JavaScript</li>
              <li>🎨 Design beautiful interfaces with Figma (UI/UX)</li>
              <li>🔐 Learn how to stay safe online (Cybersecurity basics)</li>
              <li>  Learn data Story telling, data representation and visualization </li> 
            </ul>
            <ul className="list-disc pl-6 space-y-2">
              <li>🧠 Discover how to learn tech fast & smart</li>
              <li>⚙️ Use tools like GitHub, Canva & ChatGPT</li>
              <li>🚀 Get guided on career paths in tech: dev, design, data</li>

            </ul>
             <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-pink-600 mb-6">📌 Program Details</h2>
          <ul className="text-gray-800 text-base space-y-3 list-disc pl-6">
            <li><strong>Start Date:</strong> May 21st, 2026</li>
            <li><strong>Duration:</strong> 12 Weeks (Weekdays or Weekends classes)</li>
            <li><strong>Time:</strong> 10:00 AM – 2:00 PM </li>
            <li><strong>Location:</strong> Zulfah Hub, 7 Aduke close off Maryland crescent, Maryland</li>
            <li><strong>Open To:</strong> JAMB candidates, SSCE holders, admission seekers, school leavers</li>
            <li><strong>Fees:</strong> ₦200,000 (Installment available)</li>
          </ul>
        </div>
          </div>
        </div>
      </section>

      {/* EVENT DETAILS */}
      {/* <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-pink-600 mb-6">📌 Event Details</h2>
          <ul className="text-gray-800 text-base space-y-3 list-disc pl-6">
            <li><strong>Start Date:</strong> Saturday, July 20th, 2025</li>
            <li><strong>Duration:</strong> 6 Weeks (Weekend classes)</li>
            <li><strong>Time:</strong> 10:00 AM – 2:00 PM (Saturdays)</li>
            <li><strong>Location:</strong> Zulfah Tech Hub, Lekki Phase 1, Lagos</li>
            <li><strong>Open To:</strong> JAMB candidates, SSCE holders, admission seekers, school leavers</li>
            <li><strong>Fees:</strong> ₦35,000 (Installment available)</li>
          </ul>
        </div>
      </section> */}

      {/* CALL TO ACTION */}
      <section className="bg-pink-100 py-16 px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-extrabold text-pink-700 mb-4">🎯 Don’t Just Wait. Level Up.</h2>
          <p className="text-gray-700 mb-6 text-lg">
            You don’t have to wait for school to start learning. Join other smart students and step into tech with confidence.
          </p>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSfUuvrbrRAHm-fp1O0cJlnlSO21akZDgR7Kt3i1piufsdJi_g/viewform" target="_blank" rel='noreferrer'>
          <button
            className="bg-blue-600 hover:bg-blue-700 transition px-10 py-3 rounded-full text-white text-lg shadow-lg"
          
          >
            Join the Class
          </button>
          </a>
        </div>
      </section>

    
    </div>
    </Layout>
  );
}
